
  export default {
    mounted() {
      this.initViewer();
    },

    initViewer() {
      const modelId = this.el.dataset.modelId;
      if (!modelId) return;

      const container = this.el;

      // Create iframe for Matterport embed
      const iframe = document.createElement('iframe');
      iframe.src = `https://my.matterport.com/show/?m=${modelId}&play=1&qs=1&vr=0`;
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.frameBorder = '0';
      iframe.allow = 'fullscreen; vr; xr';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'border: none; display: block;';

      // Clear any existing content and add iframe
      container.innerHTML = '';
      container.appendChild(iframe);

      // Store reference for cleanup
      this.iframe = iframe;
    },

    updated() {
      // Re-init if model ID changes
      const newModelId = this.el.dataset.modelId;
      if (this.iframe && this.iframe.src.indexOf(newModelId) === -1) {
        this.initViewer();
      }
    },

    destroyed() {
      if (this.iframe) {
        this.iframe.src = 'about:blank';
        this.iframe = null;
      }
    }
  }
